import Header from '@/pages/home/components/Header';
import HeroMosaic from '@/pages/home/components/HeroMosaic';
import FeedPanel from '@/pages/home/components/FeedPanel';
import ArchiveSection from '@/pages/home/components/ArchiveSection';
import NameListSection from '@/pages/home/components/NameListSection';
import DiscussionSection from '@/pages/home/components/DiscussionSection';
import TimelineSection from '@/pages/home/components/TimelineSection';
import CollectionsSection from '@/pages/home/components/CollectionsSection';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body">
      <Header />
      <main>
        <HeroMosaic />
        <FeedPanel />
        <ArchiveSection />
        <NameListSection />
        <DiscussionSection />
        <TimelineSection />
        <CollectionsSection />
      </main>
      <SiteFooter />
    </div>
  );
}